var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "apportionment-details" },
    [
      _c(
        "sdz-modal",
        {
          ref: "sdzModalRef",
          attrs: {
            width: "450",
            title: "Detalhes do rateio",
            "buttons-position": "right",
            "hide-cancel-button": "",
            "hide-confirm-button": "",
            "close-icon": "",
          },
          on: { close: _vm.close },
        },
        [
          _c(
            "div",
            { staticClass: "apportionment-details-content" },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "", row: "" } },
                [
                  _c("v-flex", { attrs: { lg12: "" } }, [
                    _c("div", [
                      _c("h3", [
                        _vm._v("\n              Rateio\n            "),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.details.name ? _vm.details.name : "Grupo")
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { lg12: "" } }, [
                    _c("div", [
                      _c("h3", [
                        _vm._v("\n              Tipo do Rateio\n            "),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.onApportionmentTypeType(
                              _vm.details.apportionmentType
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { lg12: "" } }, [
                    _c("div", [
                      _c("h3", [
                        _vm._v(
                          "\n              Visível para vendedor\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.details.visibleToSeller ? "Sim" : "Não")
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { lg12: "" } }, [
                    _c("div", [
                      _c("h3", [
                        _vm._v("\n              Acelerador\n            "),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.onAcceleratorType(_vm.details.acceleratorType)
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-divider", { staticClass: "mt-3 mb-3" }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { lg12: "" } },
                    [
                      _c("div", { staticClass: "functions" }, [
                        _c("div", { staticClass: "item" }, [
                          _c("h3", [
                            _vm._v("\n                Função:\n              "),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v(
                              "\n                Vendedor\n              "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.details.ownerProportion) +
                              "%\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.details.rules,
                        function ({ proportionRole, proportionValue }, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "functions" },
                            [
                              _c("div", { staticClass: "item" }, [
                                _c("h3", [
                                  _vm._v(
                                    "\n                Função:\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "ml-2" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(proportionRole) +
                                      "\n              "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(proportionValue) +
                                    "%\n            "
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("v-divider", { staticClass: "mt-3 mb-3" }),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { lg12: "" } }, [
                    _c(
                      "div",
                      [
                        _c("h3", [
                          _vm._v("\n              Parceiros\n            "),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.details.partners,
                          function ({ name }, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(name) +
                                  "\n            "
                              ),
                            ])
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }